export const getUser = () => {
  try { return JSON.parse(localStorage.getItem("jury_user")); } catch { return null; }
};

export const getToken = () => localStorage.getItem("jury_token");

export const isAdmin = () => {
  if (!getToken()) return false;
  return localStorage.getItem("jury_role") === "admin";
};

export const isJury = () => {
  if (!getToken()) return false;
  return localStorage.getItem("jury_role") === "jury";
};

/* ── Jury declaration ─────────────────────────────────────────────────────
   The declaration is required once per session. This flag only controls the
   modal — the API refuses to record a score without a fresh acceptance, so a
   refresh or a direct URL cannot get past it.
------------------------------------------------------------------------- */

export const hasDeclared = () => localStorage.getItem("jury_declared") === "true";

export const markDeclared = () => localStorage.setItem("jury_declared", "true");

export const clearDeclaration = () => localStorage.removeItem("jury_declared");

export const logout = () => {
  localStorage.removeItem("jury_token");
  localStorage.removeItem("jury_user");
  localStorage.removeItem("jury_role");
  clearDeclaration();
  window.location.href = "/login";
};
